import React from "react";
import { motion } from "framer-motion";
import { FlaskConical, Globe2, Lightbulb, Star, ShoppingCart, BookOpenCheck, BrainCircuit } from "lucide-react";

const items = [
  { icon: FlaskConical, title: "Research Grounded", text: "Every strategy is built on evidence, not guesswork." },
  { icon: Globe2, title: "International Professional Experience", text: "Insight shaped across global banking and business." },
  { icon: Lightbulb, title: "Practical Advice", text: "Actionable systems you can apply immediately." },
  { icon: Star, title: "Independent Goodreads Reviews", text: "Honest validation from real readers." },
  { icon: ShoppingCart, title: "Available Worldwide on Amazon", text: "Accessible to readers everywhere." },
  { icon: BookOpenCheck, title: "Evidence-Based Learning", text: "Methods that reflect how people actually learn." },
  { icon: BrainCircuit, title: "Modern AI Thinking", text: "Guidance built for an AI-powered world." },
];

export default function TrustSection() {
  return (
    <section id="trust" className="py-28 sm:py-36 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">Credibility</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4">Why Readers Trust Kate Mercer</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="bg-white border border-gray-100 rounded-2xl p-6 flex items-start gap-4 gold-glow"
                data-testid={`trust-item-${i}`}
              >
                <span className="shrink-0 h-11 w-11 rounded-xl bg-gold/12 text-gold grid place-items-center">
                  <Icon size={20} />
                </span>
                <div>
                  <p className="font-semibold text-[15px] leading-snug">{it.title}</p>
                  <p className="text-sm text-gray-500 mt-1 leading-relaxed">{it.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
